import * as actionTypes from "./actionTypes";

export const events = ["load", "mousemove", "mousedown", "click", "scroll", "keypress"] as const;

const dispatchLogOut = (redirectPath = "/") => ({
  redirectPath,
  type: actionTypes.LOG_OUT,
});

const updateAllSessionTimers = (idleTime: string) => {
  Object.keys(localStorage)
    .filter((key) => key.startsWith("timer-"))
    .forEach((key) => localStorage.setItem(key, idleTime));
};

export const resetSessionTimeout = () => {
  updateAllSessionTimers("0");
};

export const logOut =
  ({
    history = null,
    redirectPath = "/",
    useRedirectScreen = false,
  }: {
    history?: { replace: (path: string) => void } | null;
    redirectPath?: string;
    useRedirectScreen?: boolean;
  } = {}) =>
  (dispatch: (action: any) => void) => {
    // NOTE: useRedirectScreen=true without history is a silent no-op (no redirect occurs).
    // In practice all callers that set useRedirectScreen=true also pass history, so this
    // is unreachable today. If that ever changes, add a window.location.replace("/redirect")
    // fallback here mirroring the useRedirectScreen=false branch below.
    if (useRedirectScreen && history) {
      history.replace("/redirect");
    }

    // clearFlagInterval is not called directly here — featureFlagMiddleware intercepts
    // LOG_OUT and handles it. Due to async timing the flag polling interval may fire
    // one extra tick after logout; this is acceptable and matches the intended cleanup path.
    dispatch(dispatchLogOut(redirectPath));

    // prevents the current page from re-rendering trying to access
    // state information that is wiped by dispatching the above actions
    if (history && !useRedirectScreen) {
      history.replace("/auth/sign-in");
    } else if (!history && !useRedirectScreen) {
      // no history reference (e.g. called from network hooks) — hard-navigate
      window.location.replace("/auth/sign-in");
    }

    for (const event of events) {
      window.removeEventListener(event, resetSessionTimeout);
    }
  };
